var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgProgressBarFlaginline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28.019,
  height: 39.257
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 811"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 784"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1235",
  d: "M.962 28.521c-.282 0-.51-.155-.51-.346V2.598c0-.191.228-.346.51-.346s.51.155.51.346v25.577c0 .191-.228.346-.51.346",
  fill: "#eba47f"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1236",
  d: "M.962 28.745c-.42 0-.762-.233-.762-.519V2.519C.2 2.233.542 2 .962 2s.762.233.762.519v25.706c0 .286-.342.519-.762.519m0-26.4c-.142 0-.258.079-.258.176v25.705c0 .1.116.176.258.176s.258-.079.258-.176V2.519c0-.1-.116-.176-.258-.176",
  fill: "#333548"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 783"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1237",
  d: "M26.687 6.966H1.267A1.015 1.015 0 0 1 .252 5.949v-3.07a1.015 1.015 0 0 1 1.015-1.015h25.42a1.015 1.015 0 0 1 1.015 1.015v3.07a1.015 1.015 0 0 1-1.015 1.015",
  fill: "#fcfcfc"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1238",
  d: "M2.742 4.417H.821a.314.314 0 0 1-.314-.314V2.727a.86.86 0 0 1 .86-.86h1.375a.314.314 0 0 1 .314.314v1.921a.314.314 0 0 1-.314.314",
  fill: "#858985"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1239",
  d: "M8.181 4.417H6.264a.314.314 0 0 1-.314-.314V2.181a.314.314 0 0 1 .314-.314h1.921a.314.314 0 0 1 .314.314v1.921a.314.314 0 0 1-.314.314",
  fill: "#858985"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1240",
  d: "M13.62 4.417h-1.921a.314.314 0 0 1-.314-.314V2.181a.314.314 0 0 1 .314-.314h1.921a.314.314 0 0 1 .314.314v1.921a.314.314 0 0 1-.314.314",
  fill: "#858985"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1241",
  d: "M19.059 4.417h-1.921a.314.314 0 0 1-.314-.314V2.181a.314.314 0 0 1 .314-.314h1.921a.314.314 0 0 1 .314.314v1.921a.314.314 0 0 1-.314.314",
  fill: "#858985"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1242",
  d: "M24.498 4.417h-1.921a.314.314 0 0 1-.314-.314V2.181a.314.314 0 0 1 .314-.314h1.921a.314.314 0 0 1 .314.314v1.921a.314.314 0 0 1-.314.314",
  fill: "#858985"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1243",
  d: "M5.461 6.966H3.54a.314.314 0 0 1-.314-.314V4.73a.314.314 0 0 1 .314-.314h1.921a.314.314 0 0 1 .314.314v1.921a.314.314 0 0 1-.314.314",
  fill: "#858985"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1244",
  d: "M10.901 6.966H8.98a.314.314 0 0 1-.314-.314V4.73a.314.314 0 0 1 .314-.314h1.921a.314.314 0 0 1 .314.314v1.921a.314.314 0 0 1-.314.314",
  fill: "#858985"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1245",
  d: "M16.339 6.966h-1.921a.314.314 0 0 1-.314-.314V4.73a.314.314 0 0 1 .314-.314h1.921a.314.314 0 0 1 .314.314v1.921a.314.314 0 0 1-.314.314",
  fill: "#858985"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1246",
  d: "M21.781 6.966H19.86a.314.314 0 0 1-.314-.314V4.73a.314.314 0 0 1 .314-.314h1.921a.314.314 0 0 1 .314.314v1.921a.314.314 0 0 1-.314.314",
  fill: "#858985"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1247",
  d: "M26.892 6.966h-1.6a.314.314 0 0 1-.314-.314V4.73a.314.314 0 0 1 .314-.314h1.921a.314.314 0 0 1 .314.314v1.6a.639.639 0 0 1-.639.639",
  fill: "#858985"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1248",
  d: "M26.687 7.218H1.267A1.268 1.268 0 0 1 0 5.952v-3.07a1.268 1.268 0 0 1 1.267-1.267h25.42a1.268 1.268 0 0 1 1.267 1.267v3.07a1.268 1.268 0 0 1-1.267 1.267m-25.421-5.1a.763.763 0 0 0-.763.763v3.07a.763.763 0 0 0 .763.763h25.421a.763.763 0 0 0 .763-.763v-3.07a.763.763 0 0 0-.763-.763Z",
  fill: "#333548"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1249",
  d: "M2.742 4.669H.826a.567.567 0 0 1-.566-.566V2.727a1.113 1.113 0 0 1 1.112-1.112h1.37a.567.567 0 0 1 .566.566v1.917a.567.567 0 0 1-.566.566m-1.375-2.55a.609.609 0 0 0-.608.608v1.376a.062.062 0 0 0 .062.062h1.921a.062.062 0 0 0 .062-.062V2.181a.062.062 0 0 0-.062-.062Z",
  fill: "#333548"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1250",
  d: "M8.181 4.669H6.26a.567.567 0 0 1-.566-.566V2.181a.567.567 0 0 1 .566-.566h1.921a.567.567 0 0 1 .566.566v1.917a.567.567 0 0 1-.566.566M6.26 2.114a.062.062 0 0 0-.062.062v1.922a.062.062 0 0 0 .062.062h1.921a.062.062 0 0 0 .062-.062V2.181a.062.062 0 0 0-.062-.062Z",
  fill: "#333548"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1251",
  d: "M13.62 4.669H11.7a.567.567 0 0 1-.566-.566V2.181a.567.567 0 0 1 .566-.566h1.921a.567.567 0 0 1 .566.566v1.917a.567.567 0 0 1-.566.566M11.7 2.119a.062.062 0 0 0-.062.062v1.917a.062.062 0 0 0 .062.062h1.921a.062.062 0 0 0 .062-.062V2.181a.062.062 0 0 0-.062-.062Z",
  fill: "#333548"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1252",
  d: "M19.059 4.669h-1.921a.567.567 0 0 1-.566-.566V2.181a.567.567 0 0 1 .566-.566h1.921a.567.567 0 0 1 .566.566v1.917a.567.567 0 0 1-.566.566m-1.921-2.55a.062.062 0 0 0-.062.062v1.922a.062.062 0 0 0 .062.062h1.921a.062.062 0 0 0 .062-.062V2.181a.062.062 0 0 0-.062-.062Z",
  fill: "#333548"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1253",
  d: "M24.498 4.669h-1.921a.567.567 0 0 1-.566-.566V2.181a.567.567 0 0 1 .566-.566h1.921a.567.567 0 0 1 .566.566v1.917a.567.567 0 0 1-.566.566m-1.921-2.55a.062.062 0 0 0-.062.062v1.922a.062.062 0 0 0 .062.062h1.921a.062.062 0 0 0 .062-.062V2.181a.062.062 0 0 0-.062-.062Z",
  fill: "#333548"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1254",
  d: "M5.462 7.218H3.541a.567.567 0 0 1-.566-.566V4.73a.567.567 0 0 1 .566-.566h1.921a.567.567 0 0 1 .566.566v1.921a.567.567 0 0 1-.566.566m-1.921-2.55a.062.062 0 0 0-.062.062V6.65a.062.062 0 0 0 .062.062h1.921a.062.062 0 0 0 .062-.062V4.73a.062.062 0 0 0-.062-.062Z",
  fill: "#333548"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1255",
  d: "M10.9 7.218H8.979a.567.567 0 0 1-.566-.566V4.73a.567.567 0 0 1 .566-.566H10.9a.567.567 0 0 1 .566.566v1.921a.567.567 0 0 1-.566.566m-1.921-2.55a.062.062 0 0 0-.062.062V6.65a.062.062 0 0 0 .062.062H10.9a.062.062 0 0 0 .062-.062V4.73a.062.062 0 0 0-.062-.062Z",
  fill: "#333548"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1256",
  d: "M16.342 7.218h-1.921a.567.567 0 0 1-.566-.566V4.73a.567.567 0 0 1 .566-.566h1.921a.567.567 0 0 1 .566.566v1.921a.567.567 0 0 1-.566.566m-1.921-2.55a.062.062 0 0 0-.062.062V6.65a.062.062 0 0 0 .062.062h1.921a.062.062 0 0 0 .062-.062V4.73a.062.062 0 0 0-.062-.062Z",
  fill: "#333548"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1257",
  d: "M21.778 7.218h-1.921a.567.567 0 0 1-.566-.566V4.73a.567.567 0 0 1 .566-.566h1.921a.567.567 0 0 1 .566.566v1.921a.567.567 0 0 1-.566.566m-1.921-2.55a.062.062 0 0 0-.062.062V6.65a.062.062 0 0 0 .062.062h1.921a.062.062 0 0 0 .062-.062V4.73a.062.062 0 0 0-.062-.062Z",
  fill: "#333548"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1258",
  d: "M26.892 7.218h-1.6a.567.567 0 0 1-.566-.566V4.73a.567.567 0 0 1 .566-.566h1.924a.567.567 0 0 1 .566.566v1.6a.892.892 0 0 1-.891.891m-1.6-2.55a.062.062 0 0 0-.062.062v1.921a.062.062 0 0 0 .062.062h1.6a.388.388 0 0 0 .387-.387v-1.6a.062.062 0 0 0-.062-.062Z",
  fill: "#333548"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 229",
  fill: "none",
  d: "M0 0h27.954v39.257H0z"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 810"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1233",
  d: "M27.257 34.569c-.282 0-.51-.163-.51-.363V7.339c0-.2.228-.363.51-.363s.51.163.51.363v26.867c0 .2-.228.363-.51.363",
  fill: "#eba47f"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1234",
  d: "M27.257 34.755c-.42 0-.762-.245-.762-.546V7.18c0-.3.342-.546.762-.546s.7-1.132.7-.831l.062 28.406c0 .3-.342.546-.762.546m0-27.76c-.142 0-.258.083-.258.185v27.029c0 .1.116.185.258.185s.258-.083.258-.185V7.18c0-.1-.116-.185-.258-.185",
  fill: "#333548"
})))));
export default SvgProgressBarFlaginline;